
import React from 'react';
import { Button } from "@/components/ui/button";
import { useNavigate } from 'react-router-dom';
import { Lock, CreditCard } from "lucide-react";
import { useSubscriptionStatus } from '@/hooks/useSubscriptionStatus';

interface SubscriptionLockProps {
  title: string;
  description: string;
  buttonText?: string;
  returnPath?: string;
}

export const SubscriptionLock: React.FC<SubscriptionLockProps> = ({
  title,
  description,
  buttonText = "Débloquer l'accès",
  returnPath = '/dashboard'
}) => {
  const navigate = useNavigate();
  const { redirectToPayment } = useSubscriptionStatus();

  return (
    <div className="flex-1 flex flex-col items-center justify-center p-6 bg-gradient-to-br from-slate-50/50 to-slate-100/30 dark:from-slate-900/50 dark:to-slate-800/30">
      <div className="text-center w-full max-w-md px-6 sm:px-8 py-10 sm:py-12 rounded-2xl bg-white/80 dark:bg-[#1a1d2d]/70 backdrop-blur-md shadow-xl border border-gray-100/80 dark:border-gray-700/30 transition-all duration-300 hover:shadow-2xl">
        <div className="mx-auto bg-gradient-to-br from-indigo-500 to-purple-600 h-16 sm:h-20 w-16 sm:w-20 flex items-center justify-center rounded-full mb-5 sm:mb-6 shadow-lg shadow-indigo-500/20 dark:shadow-indigo-600/20">
          <Lock className="h-8 sm:h-10 w-8 sm:w-10 text-white" />
        </div>
        <h3 className="text-xl sm:text-2xl font-bold text-gray-800 dark:text-white mb-2 sm:mb-3">
          {title}
        </h3>
        <p className="text-sm sm:text-base text-gray-600 dark:text-gray-300 mb-6 sm:mb-8 max-w-sm mx-auto">
          {description}
        </p>
        <div className="flex justify-center">
          <Button 
            onClick={redirectToPayment}
            className="w-full max-w-xs bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white font-medium py-2 px-4 rounded-lg shadow-md shadow-indigo-500/20 transition-all duration-300 hover:shadow-lg"
          >
            <CreditCard className="h-4 w-4 mr-2" />
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};
